// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3xH1em2AuB1VkSMGTuFUE2"};